/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState, useMemo } from "react";
import "./Home.css";
import InputAdornment from "@mui/material/InputAdornment";
import { ReactComponent as Dotsicon } from "./assets/dots.svg";
import { ReactComponent as Searchicon } from "./assets/searchicon.svg";
import { ReactComponent as Editicon } from "./assets/editicon.svg";
import { ReactComponent as Deleteicon } from "./assets/deleteicon.svg";
import { ReactComponent as Downloadicon } from "./assets/downloadicon.svg";
import { ReactComponent as ViewIcon } from "./assets/viewicon.svg";
import { ReactComponent as CloseICon } from "./assets/closeicon.svg";
import { ReactComponent as DownloadBtnIcon } from "./assets/downloadbtnicon.svg";
import { ReactComponent as RefreshIcon } from "./assets/refreshicon.svg";
import { ReactComponent as StatusIcon } from "./assets/statusicon.svg";
import { ReactComponent as NewIcon } from "./assets/newicon.svg";
import { ReactComponent as SelectIcon } from "./assets/selecticon.svg";
import { ReactComponent as RejectIcon } from "./assets/rejecticon.svg";
import { ReactComponent as MoveIcon } from "./assets/moveicon.svg";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Addcandidate from "./Addcandidate";
import PreviewEditModal from "./Previeweditmodal";
import DeleteCandidateModal from "./Deletemodal";
import InfoModal from "./Infomodal";
import Statuswidget from "./Statuswidget";
import CandidateStatus from "./Candidatestatus";
import { Dialog, DialogTitle, DialogContent } from "@mui/material";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import AdduserList from "./AdduserList";
import { CSVLink } from "react-csv";
import CircularProgress from "@mui/material/CircularProgress";
import axiosInstance from "./utils/axios";
import { businessUnitOption } from './utils/constatnts';
import { referral_window_open } from './utils/constatnts';
import { Candidates } from './utils/constatnts';
import {
    MaterialReactTable,
    useMaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    type MRT_ColumnDef,
  } from 'material-react-table';

export default function Home(props: any) {
    const [rows, setRows] = useState<Candidates[]>([]);
    const [value, setValue] = React.useState("1");
    const [isEditDialogOpen, setisEditDialogOpen] = useState(false);
    const [isDeleteDialogOpen, setisDeleteDialogOpen] = useState(false);
    const [rowItem, setRowItem] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [statusdialogopen, setStatusDialogOpen] = React.useState(false);
    const [viewURL, setViewURL] = React.useState("");
    const [filetype, setFileType] = React.useState("");
    const [userRow, setUserRow] = React.useState<any>([]);
    const userEmail = props.Email;
    const [userRole, setUserRole] = React.useState("");
    const [loading, setLoading] = useState(false);
    const [iconloading, setIconLoading] = useState(false);
    const [statuscount, setStatusCount] = useState<any>([]);
    const [tablabelvalue, setTabTitleValue] = useState<any>("");
    const [statuswidgetcount, setStatusWidgetCount] = useState<any>([]);
    const [statustotalcount, setStatusTotalCount] = useState<any>([]);

    // function getUserRole(email: string) {
    //     const user = userRow.find(
    //         (user: any) => user.email.toLowerCase() === email.toLowerCase()
    //     );
    //     return user ? user.role : "user";
    // }

    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        // console.log(newValue);
        setValue(newValue);
        setTabTitleValue(event.currentTarget.textContent);
    };

    const CutsomTooltip = styled(({ className, ...props }: TooltipProps) => (
        <Tooltip {...props} arrow classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.arrow}`]: {
            color: theme.palette.common.black,
        },
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: theme.palette.common.black,
        },
    }));

    const getTooltipContent = (row: any) => {
        // Access other data from rowData to construct the tooltip content
        // const additionalInfo = rowData.additionalProperty;
        return (
            <div>
                <p>Created By: {row.original.created_by}</p>
                <p>Created At: {convertDateFormat(row.original.createdAt)}</p>
                <p>Last Modified By: {row.original.modified_by}</p>
                <p>Last Modified At: {convertDateFormat(row.original.updatedAt)}</p>
            </div>
        );
    };

    const getCandidateList = async () => {
        if(userRole !== "user"){
        setLoading(true);
        axiosInstance
            .get(`/candidatelist?role=${userRole}`)
            .then((response: any) => {
                // setData(response.data) as any;
                setRows(response.data);
                setLoading(false);
                // console.log(response.data);
            })
            .catch((error) => {
                console.log(error.response.data.error);
                setLoading(false);
            });
        }
    };

    useEffect(() => {
        if (userRole !== "") {
            getCandidateList();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userRole]);

    const getUserList = async () => {
        axiosInstance
            .get("/userlist")
            .then((response: any) => {
                setUserRow(response.data);
                const user = response.data.find(
                    (user: any) =>
                        user.email.toLowerCase() === userEmail.toLowerCase()
                );
                let role = user ? user.role : "user";
                setUserRole(role);
            })
            .catch((error) => {
                console.log(error.response.data.error);
            });
    };

    useEffect(() => {
        getUserList();
    }, []);

    const handleRefreshrecords = () => {
        getCandidateList();
    };
    const handleEditItemClick = (row: any) => {
        // console.log(row.id)
        setRowItem(row);
        setisEditDialogOpen(!isEditDialogOpen);
    };

    const handleDelteItemClick = (row: any) => {
        setRowItem(row);
        setisDeleteDialogOpen(!isDeleteDialogOpen);
    };

    const handleDownload = (rowid: any) => {
        setIconLoading(true);
        let postUrl = "/candidatelist/downloaddocs";
        let postData = { row_id: rowid };
        axiosInstance(postUrl, {
            method: "POST",
            data: postData,
            headers: {
                // 'Authorization': `bearer ${token}`,
                "Content-Type": "application/json",
            },
        })
            .then((response: any) => {
                if (response) {
                    const respdata = response.data[0];
                    // console.log(response.data[0].name);
                    const fileDataArray = new Uint8Array(
                        respdata.file_data.data
                    );
                    const blob = new Blob([fileDataArray], {
                        type: respdata.file_type,
                    });
                    const link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.setAttribute("download", respdata.file_name);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    setIconLoading(false);
                }
            })
            .catch((error) => {
                setIconLoading(false);
                console.log(error);
            });
    };

    const columns: any = useMemo<MRT_ColumnDef<Candidates>[]>(
        () => [
          {
            accessorKey: 'name', //access nested data with dot notation
            header: 'Name',
            size:110,
            minSize:110,
            maxSize:200,
            Cell: ({ cell, row }) => (

                <CutsomTooltip 
                    title={getTooltipContent(row)} placement="bottom" arrow
                    enterDelay={300} leaveDelay={200} 
                    sx={{ cursor:"pointer"}}>
                  <span>{cell.getValue<string>()}</span>
                 </CutsomTooltip>
              ),
      
          },
          {
            accessorKey: 'email',
            header: 'Email',
            size:140,
            minSize:140,
            maxSize:220,
          },
          {
            accessorKey: 'skills',
            header: 'Skills',
            size:200,
            minSize:200,
            maxSize:250,
          },
          {
            accessorKey: 'referrer_positionid',
            header: 'Position ID',
            size:50,
            minSize:50,
            maxSize:150,
            filterFn: (row, id, filterValue) => {
                const cellValue = row.getValue(id);
                const stringValue = cellValue == null ? '' : String(cellValue); // Handle null/undefined
                return stringValue.toLowerCase().includes(filterValue.toLowerCase());
              }
          },
          {
            accessorKey: 'position',
            header: 'Position',
            size:50,
            minSize:50,
            maxSize:150,
          },
          {
            accessorKey: 'status',
            header: 'Status',
            size:100,
            minSize:100,
            maxSize:200,
            filterFn: (row, id, filterValue) => {
                const cellValue = row.getValue(id);
                const stringValue = cellValue == null ? '' : String(cellValue); // Handle null/undefined
                return stringValue.toLowerCase().includes(filterValue.toLowerCase());
              }
          },
        ],
        [],
      );

    const sortedrows = rows.sort((a, b) => {
        if (a.status === "New") return -1;
        if (b.status === "New") return 1;
        return 0;
      });

      const table = useMaterialReactTable({
        columns,
        data: sortedrows,
        enableRowActions:true,
        positionActionsColumn: "last",
        enableSorting:false,
        enableColumnActions: false,
        enableDensityToggle: false,
        enableFullScreenToggle: false,
        enableHiding: false,
        initialState: {showGlobalFilter: true,density:"comfortable"},
        positionGlobalFilter: 'left',
        globalFilterFn: 'customFilter',
        filterFns: {
            customFilter: (row, columnId, filterValue) => {
                const value = row.getValue(columnId);

                if (typeof value === 'object') {
                // Customize how to stringify objects or arrays
                return JSON.stringify(value).toLowerCase().includes(filterValue.toLowerCase());
                }

                return String(value || '').toLowerCase().includes(filterValue.toLowerCase());
            }
        },
        renderRowActions: ({ row, table }) => (
            <>
                <Editicon
                    style={{ cursor: "pointer"}}
                    onClick={() =>
                        handleEditItemClick(row.original)
                    }
                />
                {userRole !== "panel" && (
                    <Deleteicon
                        style={{marginLeft:"8px",cursor: "pointer"}}
                        onClick={() =>
                            handleDelteItemClick(row.original)
                        }
                    />
                )}
                <Downloadicon
                    className="icon-section"
                    onClick={() =>
                        handleDownload(row.original.id)
                    }
                />
                <ViewIcon
                    className="icon-section"
                    onClick={() =>
                        handleDocViewOpen(row.original)
                    }
                />
            </>
            
        ),
        renderTopToolbar: ({ table }) => (
            <div className="custom-table-renderer">
                <div className="globafilter-section">
                    <MRT_GlobalFilterTextField table={table} style={{width:"27em"}}/>
              </div>
                <div className="togglefilter-section">
                    <MRT_ToggleFiltersButton table={table}
                    
                    style={{
                        color:"#fff",
                        background:"#6a807a",
                        borderRadius:"5px",
                        position:"relative",
                        top:"10px",
                        border:"1px solid #a9a9a9",
                        padding:"6px",
                    }}/>
              </div>
            </div>
          ),
        muiTableBodyProps: {
            sx: {
              //stripe the rows, make odd rows a darker color
              '& tr:nth-of-type(odd) > td': {
                backgroundColor: 'rgba(73, 134, 194, 0.11)',
              },
              borderBottom: "none",
            },
          },
          muiSearchTextFieldProps:{
            placeholder:"Search...",
            style:{minWidth:"30em !important"},
            InputProps:{
                startAdornment:(
                    <InputAdornment position="start">
                        <Searchicon />
                    </InputAdornment>
                )
            }
          },
          muiPaginationProps: {
            rowsPerPageOptions: [5, 10, 25, 50],
            showFirstButton: false,
            showLastButton: false,
          },
          
    });

    const filteredrows = table.getFilteredRowModel().rows.map(row => row.original);

    const handleBusinessUnitchange = (unit: any) => {
        let filteredByUnit: any = [];
        if(unit === "Cable"){
            filteredByUnit = rows.filter((item: any) => (!item.referrer_positionid.toLowerCase().includes("sky") && 
                             !item.referrer_positionid.includes("NBCU")));
        } else if(unit === "SKY"){
            filteredByUnit = rows.filter((item: any) => item.referrer_positionid.toLowerCase().includes("sky"));
        } else if(unit === "NBCU"){
            filteredByUnit = rows.filter((item: any) => item.referrer_positionid.includes("NBCU"));
        } else{
            filteredByUnit = rows.filter((item: any) => item.referrer_positionid.includes(unit));
        }
        const countMap: any = {};
        filteredByUnit.forEach((item: any) => {
        const { status } = item;
        countMap[status] = (countMap[status] || 0) + 1;
        });
        // console.log(countMap);
        setStatusCount(countMap);
    };

    const handleDocViewOpen = (row: any) => {
        if(row.file_type === "application/pdf"){
            setIconLoading(true);
            setOpen(true);
        }
        let postUrl = "/candidatelist/downloaddocs";
        let postData = { row_id: row.id };
        axiosInstance(postUrl, {
            method: "POST",
            data: postData,
            headers: {
                // 'Authorization': `bearer ${token}`,
                "Content-Type": "application/json",
            },
        })
            .then((response: any) => {
                if (response) {
                    const respdata = response.data[0];
                    const fileDataArray = new Uint8Array(
                        respdata.file_data.data
                    );
                    const blob = new Blob([fileDataArray], {
                        type: respdata.file_type,
                    });
                    const link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    if (respdata.file_type === "application/pdf") {
                        // setOpen(true);
                        setViewURL(link.href);
                        setFileType(respdata.file_type);
                    } else {
                        link.setAttribute("download", respdata.file_name);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        // setOpen(true);
                        // setViewURL(filePath);
                        // setFileType(respdata.file_type);
                    }
                    setIconLoading(false);
                }
            })
            .catch((error) => {
                setIconLoading(false);
                console.log(error);
            });
        
    };

    const handleDocViewClose = () => {
        setOpen(false);
    };

    const handleStatusDialogClose = () => {
        setStatusDialogOpen(false);
        setStatusCount({});
    };

    const handleStatusDialogOpen = () => {
        setStatusDialogOpen(true);
    };

    const handleStatusCount = (cStatusCount: any, totalStatuscount: any) => {
        // Handle the status received from the child
        // console.log('Parent received new status:', cStatusCount);
        setStatusTotalCount(totalStatuscount)
        setStatusWidgetCount(cStatusCount)
    };

    function convertDateFormat(date: any) {
        let dateString = new Date(date);
        const dateformat = dateString
            .toLocaleString()
            .replace("T", " ")
            .substring(0, 20);
        return dateformat;
    }

    return (
        <div className="home-section">
            <div className="header-outer">
                <div className="header-container">
                    <h4 style={{ margin: 0 }}>
                        <Dotsicon
                            style={{ position: "relative", top: "7px" }}
                        />
                        <span style={{ paddingLeft: "8px" }}>
                            Welcome to Referral Portal
                        </span>
                    </h4>
                </div>
            </div>
            <div className="container-section">
                {value &&
                    <Statuswidget tabLabelValue={tablabelvalue} 
                        statusWidgetCount = {statuswidgetcount} getTotalStatusCount = {statustotalcount}/>
                }
                <div className="table-section">
                    <TabContext value={value}>
                        <TabList
                            sx={{
                                borderBottom: "1px solid #cdcdcd",
                                paddingTop: "1.25em",
                                width: "95%",
                                margin: "0 auto",
                            }}
                            onChange={handleTabChange}
                        >
                            {userRole !== "user" && (
                                <Tab
                                    label="Candidate Search"
                                    value="2"
                                    style={{
                                        minWidth: "25%",
                                        fontSize: "16px",
                                        fontWeight: "600",
                                        textTransform: "capitalize",
                                    }}
                                />
                                
                            )}
                            <Tab
                                label="Candidate Upload"
                                value="1"
                                style={{
                                    minWidth: "25%",
                                    fontSize: "16px",
                                    fontWeight: "600",
                                    textTransform: "capitalize",
                                }}
                            />
                            <Tab
                                label="Candidate Status"
                                value="4"
                                style={{
                                    minWidth: "25%",
                                    fontSize: "16px",
                                    fontWeight: "600",
                                    textTransform: "capitalize",
                                }}
                            />
                            {userRole === "superadmin" && (
                                <Tab
                                    label="Add / Edit"
                                    value="3"
                                    style={{
                                        minWidth: "25%",
                                        fontSize: "16px",
                                        fontWeight: "600",
                                        textTransform: "capitalize",
                                    }}
                                />
                            )}
                        </TabList>
                        {userRole === "superadmin" && (
                            <TabPanel value="3" sx={{ padding: "0" }}>
                                <AdduserList
                                    getUserList={getUserList}
                                    userRow={userRow}
                                />
                            </TabPanel>
                        )}
                        <TabPanel
                            value="1"
                            sx={{ padding: "0", margin: "3em 0 0em 0" }}
                        >
                        
                            <div className="add-section">
                                <Addcandidate
                                    getCandidateList={getCandidateList}
                                    email={props.Email}
                                    referrer_name={props.referrName}
                                    userRole={userRole}
                                />
                            </div>
                        </TabPanel>
                        <TabPanel
                            value="4"
                            sx={{ padding: "0", margin: "3em 0 0em 0" }}
                        >
                            <div className="candidatestatus-section">
                                <CandidateStatus email={props.Email} onStatusCount={handleStatusCount}/>
                            </div>
                        </TabPanel>
                        {userRole !== "user" && (
                            <TabPanel value="2" sx={{ padding: "0", position:"relative"}}>
                               
                                {loading && (
                                    <div className="loading-section">
                                        <div>
                                            <CircularProgress size="3.5rem" />
                                        </div>
                                        <div>Loading Please wait...</div>
                                    </div>
                                )}

                                {!loading && (
                                     
                                    <div className="table-container">
                                        <div className="dowonload-btn-section">
                                     <span
                                         className="status-btn"
                                         onClick={handleStatusDialogOpen}
                                     >
                                         <StatusIcon
                                             style={{
                                                 position: "relative",
                                                 top: "7px",
                                                 // right: "8px",
                                             }}
                                             title="Status"
                                         />
                                         <span
                                             style={{
                                                 position: "relative",
                                                 right: "4px",
                                                 top: "2px"
                                             }}
                                         >
                                             {/* Status */}
                                         </span>
                                     </span>
 
                                     <span
                                         className="refresh-btn"
                                         onClick={handleRefreshrecords}
                                     >
                                         <RefreshIcon
                                             style={{
                                                 position: "relative",
                                                 top: "7px",
                                                 // right: "8px",
                                             }}
                                             title="Refresh"
                                         />
                                         <span
                                             style={{
                                                 position: "relative",
                                                 right: "4px",
                                             }}
                                         >
                                             {/* Refresh */}
                                         </span>
                                     </span>
                                     <CSVLink
                                         data={filteredrows.map(
                                             ({
                                                 id,
                                                 current_ctc,
                                                 location,
                                                 ...filteredData
                                             }) => filteredData
                                         )}
                                         className="dowonload-btn"
                                         filename={"Candidate list"}
                                     >
                                         {
                                             <DownloadBtnIcon
                                                 style={{
                                                     color: "#fff",
                                                     position: "relative",
                                                     top: "12px",
                                                     // right: "8px",
                                                 }}
                                                 title="Download"
                                             />
                                         }
                                         <span
                                             style={{
                                                 position: "relative",
                                                 top: "10px",
                                             }}
                                         >
                                             {/* Download */}
                                         </span>
                                     </CSVLink>
                                 </div>
                                        
                                        <MaterialReactTable 
                                            table={table} 
                                        />
                                    </div>
                                )}
                            </TabPanel>
                        )}
                    </TabContext>
                    <PreviewEditModal
                        isEditDialogOpened={isEditDialogOpen}
                        handleCloseDialog={() => setisEditDialogOpen(false)}
                        getCandidateList={getCandidateList}
                        getRowItem={rowItem}
                        userRole={userRole}
                        email={props.Email}
                    />
                    <DeleteCandidateModal
                        isDeleteDialogOpened={isDeleteDialogOpen}
                        handleCloseDialog={() => setisDeleteDialogOpen(false)}
                        getCandidateList={getCandidateList}
                        getRowItem={rowItem}
                    />
                </div>
            </div>
            <Dialog
                open={open}
                onClose={handleDocViewClose}
                fullWidth
                maxWidth="md"
            >
                <div>
                    <DialogTitle>
                        <div style={{ textAlign: "right" }}>
                            <CloseICon
                                style={{ cursor: "pointer" }}
                                onClick={() => handleDocViewClose()}
                            />
                        </div>
                    </DialogTitle>
                    <DialogContent sx={{ textAlign: "center" }}>
                        { iconloading &&
                            <div className="embed-loading">
                                <div>
                                    <CircularProgress size="4rem" />
                                </div>
                                <div style={{marginTop:"2em"}}>Loading Please wait...</div>
                            </div>
                        }
                        { !iconloading &&
                        <embed
                            src={viewURL + "#toolbar=0&navpanes=0&navpanes=0&scrollbar=0"}
                            type={filetype}
                            width="850"
                            height="700"
                        />
                        }
                    </DialogContent>
                </div>
            </Dialog>
            <Dialog
                open={statusdialogopen}
                onClose={handleStatusDialogClose}
                fullWidth
                maxWidth="md"
            >
                {/* <DialogTitle>Business Unit Status</DialogTitle> */}
                <CloseICon style={{ cursor: "pointer", position: "absolute", right: 18, top: 12 }}
                    onClick={() => handleStatusDialogClose()}
                />
                <DialogContent sx={{ textAlign: "center" }}>
                    <div className="statuscard-title">Business Unit Status</div>
                    <div className="form-row" 
                         style={{border:"1px solid #aeadad", borderRadius:"2px",padding:"10px 0", marginBottom:"24px"}}>
                        <div className="row-column-label">
                            <div className="label-section">
                                <label style={{fontSize:"14px"}}>
                                   Select Business Unit
                                </label>
                            </div>
                        </div>
                        <div className="row-column-status" style={{ marginRight: "50px" }}>

                            <div>
                                <select className="select-section" style={{padding:"6px 5px"}}
                                    onChange={(event) => handleBusinessUnitchange(event.target.value)}
                                >
                                    <option>Select</option>
                                    {businessUnitOption.map((item, i) => (
                                        <option key={i}>{item}</option>
                                    ))}
                                     <option>Cable</option>
                                     <option>SKY</option>
                                </select>
                            </div>
                        </div>
                            {statuscount &&
                                <div className="row-column-status" style={{borderLeft:"1px solid #aeadad"}}>
                                    <div className="status-card" style={{background: "rgba(37,71,106)", marginTop:"16px"}}>
                                        <div className="status-cardicon"><NewIcon /></div>
                                        <div className="status-cardcontent">
                                            <div className="statuscard-number">
                                                { (statuscount["New"] || 0) + (statuscount["Interviews are in Progress"] || 0) +
                                                  (statuscount["Shared for Hiring Manager Review"] || 0)
                                                }
                                            </div>
                                            <div className="statuscard-item">Review</div>
                                        </div>
                                    </div>
                                    <div className="status-card" style={{background:"#26a69a"}}>
                                        <div className="status-cardicon"><SelectIcon /></div>
                                        <div className="status-cardcontent">
                                            <div className="statuscard-number">
                                                { (statuscount["Final Select"] || 0) + (statuscount["Offered"] || 0) +
                                                  (statuscount["Joined"] || 0) + (statuscount["Offer Declined"] || 0)
                                                }
                                            </div>
                                            <div className="statuscard-item">Selected</div>
                                        </div>
                                    </div>
                                    <div className="status-card" style={{background:"#df5645"}}>
                                        <div className="status-cardicon"><RejectIcon /></div>
                                        <div className="status-cardcontent">
                                            <div className="statuscard-number">
                                                { (statuscount["Profile Reject"] || 0) + (statuscount["Technical Reject"] || 0) +
                                                  (statuscount["Manager Reject"] || 0) + (statuscount["HR Reject"] || 0) + 
                                                  (statuscount["Resume saved in the Database"] || 0) + 
                                                  (statuscount["Position Filled"] || 0)
                                                }
                                            </div>
                                            <div className="statuscard-item">Rejected</div>
                                        </div>
                                    </div>
                                    { (userRole === "admin" || userRole === "superadmin" ) &&
                                        <div className="status-card" style={{background:"#03a9f4"}}>
                                            <div className="status-cardicon"><MoveIcon /></div>
                                            <div className="status-cardcontent">
                                                <div className="statuscard-number">
                                                { (statuscount["Position on hold"] || 0) + (statuscount["Candidate on hold"] || 0) 
                                                }
                                                </div>
                                                <div className="statuscard-item">Hold</div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                        </div>

                </DialogContent>
            </Dialog>
            {!referral_window_open &&
                <InfoModal />
            }           
        </div>
    );
}
